import { nullable } from '@ipfabric/utils/fp/nullable';
import { prop } from '@ipfabric/utils/fp/prop';
import type { SecuritySchemaMergedState } from 'components/SecuritySchema/model/SecuritySchemaModel';
import {
  type ReferencedTestScope,
  isReferencedTestScope,
} from 'components/SecuritySchema/model/SecuritySchemaScope';
import { pipe } from 'fp-ts/lib/function';

export const selectReferencedTestScope = (
  state: SecuritySchemaMergedState,
): ReferencedTestScope | null =>
  pipe(state, prop('scope'), nullable.fromPredicate(isReferencedTestScope));
